import { Injectable, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { RestService } from './rest.service';

@Injectable()
export class SpinnerService {

  constructor(private restService: RestService) { }

  private stateBlockbyLoading = new BehaviorSubject<boolean>(null);
  private loadingCounter = 0;

  getStateForSearch(): Observable<boolean> {
    return this.stateBlockbyLoading;
  }

  getSubscriptionToLodaerBlockUI(): Promise<boolean> {
    return new Promise<boolean>(resolve => {
      this.restService.getStateBlockUIByLoading().subscribe(x => {
        if (x !== null && x !== undefined) {
          this.setStateForSearch(x);
          resolve(true);
        }
      });
    });
  }

  private setStateForSearch(value: boolean): void {
    if (value) {
      this.loadingCounter++;
    } else {
      this.loadingCounter > 0 ? this.loadingCounter-- : this.loadingCounter = 0;
    }
    this.stateBlockbyLoading.next(this.loadingCounter > 0);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/spinner.service.ts